<div class="d-flex align-items-center min-vh-100 bg-auth">
  <div class="container">
    <div class="justify-content-center row">
      <div class="mb-4 col-xl-4 col-md-5 col-12">
        <h1 class="display-4 text-center mb-3" translate>app.sign.up.title</h1>

        <form *ngIf="!contact" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
          <div class="form-group mb-4">
            <label class="form-label" for="contact" translate>app.sign.email</label>
            <input class="form-control" placeholder="{{'app.sign.email-address' | translate}}..." type="text"
                   name="contact" formControlName="contact" id="contact"
                   [ngClass]="{ 'invalid': submitted && fg.contact.errors }"/>
            <div class="d-block text-danger" *ngIf="submitted && fg.contact.errors">
              <div *ngIf="fg.contact.errors.required" translate>app.sign.contact.empty.error</div>
            </div>
          </div>

          <div class="form-group mb-4">
            <p class="text-justify text-stretch">
              The password for your account will be generated automatically
            </p>

            <p class="text-justify text-stretch">By clicking Sign Up, I agree to sdv291's <a routerLink="/terms-and-conditions">
              Terms of Service</a>, <a routerLink="/privacy">Privacy Policy</a>, and <a routerLink="/cookie">Cookie Policy</a>.
            </p>

            <button class="w-100 mb-3 btn btn-primary btn-lg" type="submit" [disabled]="loading" translate>
              app.sign.register
            </button>

            <p class="text-center">
              <small class="text-muted text-center">OR</small>
            </p>

            <button class="w-100 mb-3 btn btn-primary btn-lg" disabled>Sign up with Google</button>
          </div>

          <div clas="text-danger" *ngIf="error">{{ error }}</div>

          <div class="mt-20 text-center">
            Already have an account? <a routerLink="/sign-in" translate>app.sign.login</a>
          </div>
        </form>

        <form *ngIf="contact" [formGroup]="verifyFormGroup" (ngSubmit)="onVerifySubmit()">
          <div class="form-group mb-4">
            <p>Please check your email <strong>{{ contact }}</strong> and follow the link inside email or</p>

            <label class="form-label" for="code" translate>app.sign.confirm_code</label>
            <input class="form-control" placeholder="{{'app.sign.confirm-code' | translate}}..." type="text"
                   name="code" formControlName="code" id="code"
                   [ngClass]="{ 'invalid': submitted && vfg.code.errors }"/>
            <div class="d-block text-danger" *ngIf="submitted && vfg.code.errors">
              <div *ngIf="vfg.code.errors.required" translate>app.sign.confirm_code.empty.error</div>
            </div>
          </div>

          <button class="w-100 mb-3 btn btn-primary btn-lg" type="submit" [disabled]="loading" translate>
            Verify
          </button>

          <div class="text-danger" *ngIf="error">{{ error }}</div>

          <button class="w-100 mb-3 btn btn-primary btn-lg" type="button" (click)="changeContact()" translate>
            Change email address
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
